import React, { useState } from "react";
import ReactDOM from "react-dom";
import "../css/PaneldeSupervision.css";
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

const PaneldeSupervision = () => {
  const [activePage, setActivePage] = useState(1);
  const totalSets = 6;  

  const handleNextPage = () => {
    setActivePage((prevPage) => Math.min(prevPage + 1, totalSets));
  };

  const handlePrevPage = () => {
    setActivePage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handlePageChange = (event, value) => {
    setActivePage(value);
  };

  const renderSetContent = (pageNumber) => {
    switch (pageNumber) {
      case 1:
        return (
          <div className="fullWidthContainer">
            <div className="box">
              <h5 className="h5Text">Datos de Sensores en Vivo</h5>
              <iframe
                title="RSS Incidencias"
                src="https://connecta.bcn.cat/connecta-catalog-web/component/map"
                frameBorder="0"
                scrolling="yes"
                allowtransparency="true"
                style={{ width: "100%", height: "100%" }}
              ></iframe>
            </div>
          </div>
        );
      case 2:
        return (
          <div className="fullWidthContainer">
            <div className="box">
              <h5 className="h5Text">Pronóstico al Instante</h5>
              <iframe
                title="API tiempo"
                src="https://www.meteoblue.com/es/tiempo/mapas/widget/barcelona_espa%c3%b1a_3128760?windAnimation=0&windAnimation=1&gust=0&gust=1&satellite=0&satellite=1&cloudsAndPrecipitation=0&cloudsAndPrecipitation=1&temperature=0&temperature=1&sunshine=0&sunshine=1&extremeForecastIndex=0&extremeForecastIndex=1&geoloc=fixed&tempunit=C&windunit=km%252Fh&lengthunit=metric&zoom=10&autowidth=auto"
                frameBorder="0"
                scrolling="NO"
                allowtransparency="true"
                sandbox="allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox"
                style={{ width: "100%", height: "100%" }}
              ></iframe>
            </div>
          </div>
        );
      case 3:
        return (
          <div className="fullWidthContainer">
            <div className="box">
              <h5 className="h5Text">Tráfico en Directo</h5>
              <iframe
                title="API Tráfico"
                src="https://embed.waze.com/es/iframe?zoom=12&lat=41.466483&lon=2.011453"
                frameBorder="0"
                scrolling="yes"
                allowtransparency="true"
                style={{ width: "100%", height: "100%" }}
              ></iframe>
            </div>
          </div>
        );
      case 4:
        return (
          <div className="fullWidthContainer">
            <div className="box">
              <h5 className="h5Text">Agenda Urbana</h5>
              <iframe
                title="API Eventos"
                src="https://do.diba.cat/data/ds/actesturisme_es/mapa?embed=true&filters=false&export-btn=false&iframe-btn=false&info=false"
                style={{ width: "100%", height: "100%" }}
                frameBorder="0"
                scrolling="yes"
              ></iframe>
            </div>
          </div>
        );
      case 5:
        return (
          <div className="fullWidthContainer">
            <div className="box">
              <h5 className="h5Text">Tarifas Eléctricas al Minuto</h5>
              <iframe src="https://www.apaga-luz.com/graficas/" 
              width="100%" height="326"></iframe>
            </div>
          </div>
        );
      case 6:
        return (
          <div className="fullWidthContainer">
            <div className="box">
              <h5 className="h5Text">Incidencias en la Vía</h5>
              <iframe
                title="RSS Incidencias"
                src="https://cit.transit.gencat.cat/cit/AppJava/views/incidents.xhtml"
                frameBorder="0"
                scrolling="yes"
                allowtransparency="true"
                style={{ width: "100%", height: "100%" }}
              ></iframe>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <button
        className={`scroll-btn left ${activePage === 1 ? "disabled" : ""}`}
        onClick={activePage > 1 ? handlePrevPage : null}
      >
        {"<"}
      </button>
      <button
        className={`scroll-btn right ${activePage === totalSets ? "disabled" : ""}`}
        onClick={activePage < totalSets ? handleNextPage : null}
      >
        {">"}
      </button>
    {renderSetContent(activePage)}
    <div>
      <Stack spacing={2} className="pagination-stack">
              <Pagination
                count={totalSets}
                page={activePage}
                onChange={handlePageChange}
                variant="outlined"
                shape="rounded"
              />
      </Stack>
    </div>
    <div className="logos-container-supervision">
      <img src="app/ue-color.png" alt="Union" className="logo-panel" />
      <img src="app/ministerio-color.png" alt="Ministerio" className="logo-panel" />
      <img src="app/plan_recuperacion_color.png" alt="Recuperacion" className="logo-panel" />
    </div>
  </div>
  );
};

ReactDOM.render(
  <React.StrictMode>
    <PaneldeSupervision />
  </React.StrictMode>,
  document.getElementById("root")
);

export default PaneldeSupervision;
